import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppRouteId } from '../../../route-data';
import { NavigationService } from '../../navigation/services/navigation.service';
import { CustomerSearchWrapper } from './customer-search.wrapper';

@Component({
  selector: 'cdf-customer-search-page',
  imports: [CustomerSearchWrapper],
  template: `<cdf-customer-search (openCustomerProfile)="openCustomerProfile($event.accountNumber)" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSearchPage {
  private readonly navigationService = inject(NavigationService);

  async openCustomerProfile(accountNumber: string) {
    await this.navigationService.navigateToRouteId(AppRouteId.PROFILE, { params: { accountNumber } });
  }
}
